import React from "react";
import "./index.css";
export function ProtocolTable({ data }) {
  return (
    <div className="protocol-container">
      <div className="protocol-header">
        <h3 className="protocol-title">
          AICOPD AI DISEASE PREVENTION - AI RECOMMENDED PROTOCOL (FOR DR REVIEW &
          ADVISE)
        </h3>
      </div>
      <div className="protocol-table">
        <div className="protocol-row">
          <div className="protocol-category">LAB INVESTIGATION</div>
          <div className="protocol-details">{data.labInvestigation}</div>
        </div>
        <div className="protocol-row">
          <div className="protocol-category">DIAGNOSTICS AND IMAGING</div>
          <div className="protocol-details">
            {data.diagnostics_imaging &&
              Object.entries(data.diagnostics_imaging)
                .map(([key, value]) => value)
                .join(", ")}
          </div>
        </div>
        {data.next_steps && (
          <div className="protocol-row">
            <div className="protocol-category">NEXT STEPS</div>
            <div className="protocol-details">{data.next_steps}</div>
          </div>
        )}
        {data.referralToConsultant && (
          <div className="protocol-row">
            <div className="protocol-category">REFERRAL</div>
            <div className="protocol-details">{data.referralToConsultant}</div>
          </div>
        )}
        <div className="protocol-row">
          <div className="protocol-category">TREATMENT GOALS</div>
          <div className="protocol-details">{data.treatmentGoals}</div>
        </div>
        {data.educate && (
          <div className="protocol-row">
            <div className="protocol-category">EDUCATE ON</div>
            <div className="protocol-details">{data.educate}</div>
          </div>
        )}
        <div className="protocol-row">
          <div className="protocol-category">TEST FOLLOW UP</div>
          <div className="protocol-details">{data.testsFollowUp}</div>
        </div>
      </div>
    </div>
  );
}

export default ProtocolTable;
